import { appAnalytics } from 'analytics';
import { ContinueWelcome, ScreenOpened } from 'analytics/AllEvents';
import { useAppDispatch } from 'bootstrap/hooks';
import { setAnswer } from 'bootstrap/onboarding/actions';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { SyntheticEvent, useEffect } from 'react';
import { useFeatures } from 'useFeatures';

export enum Genders {
  Female = 'female',
  Male = 'male',
}

export const useLivenWelcomeLogic = () => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  useEffect(() => {
    appAnalytics.trackEvent(new ScreenOpened('onboardingWelcome'));
  }, []);

  const handleTakeTest = (e: SyntheticEvent, gender: Genders) => {
    e.preventDefault();
    appAnalytics.trackEvent(new ContinueWelcome('liven'));
    dispatch(setAnswer(QuestionIds.Welcome, gender, features));
  };

  return {
    handleTakeTest,
  };
};
